import React, { ReactNode } from 'react';
import styles from './tabs.module.scss';

interface TabsProps {
  children?: ReactNode;
}

const Tabs: React.FC<TabsProps> = ({ children }) => {
  return (
    <>
      <div className={styles.tabs}>
        <div className={styles.siteWidth}>{children}</div>
      </div>
    </>
  );
};

export default Tabs;
